var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { ContainerApiFp, ExamApiFp, StudentInfoApiFp, TestApiFp, } from "../Api/fetch/api";
import { au1h10k3N, errorMessage, URL_BASE, } from "../components/common/function/constant";
import { closeModal, usingModal, } from "../components/common/function/usingModal";
//@ts-ignore
import style from "../styles/Pointing.css";
import AppStateHOC from "../scratch-gui/lib/app-state-hoc";
import GUI from "../scratch-gui/containers/gui.jsx";
import HashParserHOC from "../scratch-gui/lib/hash-parser-hoc.jsx";
import AppTarget from "../scratch-gui/playground/render-gui";
var CryptoJS = require("crypto-js");
function useQuery() {
    return new URLSearchParams(useLocation().search);
}
export var Pointing = function () {
    var _a, _b, _c, _d, _e;
    var query = useQuery();
    var _f = useState(), authorization = _f[0], setAuthorization = _f[1];
    var _g = useState(), submitId = _g[0], setSubmitId = _g[1];
    var _h = useState(), examId = _h[0], setExamId = _h[1];
    var _j = useState(), exam = _j[0], setExam = _j[1];
    var _k = useState(), submitExam = _k[0], setSubmitExam = _k[1];
    var once = useRef([]);
    var nothingToDoHere = function () { };
    var _l = useState([]), W = _l[0], setW = _l[1];
    useEffect(function () {
        //@ts-ignore
        GUI.setAppElement(document.getElementById("pointingTarget"));
        var WrappedGui = AppStateHOC(HashParserHOC(GUI));
        setW([WrappedGui]);
    }, []);
    useEffect(function () {
        if (!!query.get("a")) {
            var dataString = query.get("a");
            if (dataString) {
                var bytes = CryptoJS.AES.decrypt(dataString
                    .replaceAll("xMl3Jk", "+")
                    .replaceAll("Por21Ld", "/")
                    .replaceAll("Ml32", "="), "vietstemvfast");
                var originalText = bytes.toString(CryptoJS.enc.Utf8);
                setAuthorization({
                    headers: {
                        authorization: originalText,
                    },
                });
            }
        }
    }, [query.get("a")]);
    useEffect(function () {
        var userId = query.get("i");
        if (userId) {
            setSubmitId(userId);
        }
    }, [query.get("i")]);
    useEffect(function () {
        var examId = query.get("ex");
        if (examId) {
            setExamId(examId);
        }
    }, [query.get("ex")]);
    var _m = useState([]), baiMau = _m[0], setBaiMau = _m[1];
    var _o = useState(-1), currentFile = _o[0], setCurrentFile = _o[1];
    var _p = useState([]), points = _p[0], setPoints = _p[1];
    var _q = useState(-1), numFile = _q[0], setNumFile = _q[1];
    var _r = useState(0), totalPoint = _r[0], setTotalPoint = _r[1];
    var _s = useState(), maxPoints = _s[0], setMaxPoint = _s[1];
    var numOfMulti = 0;
    var tmp = useRef(0);
    var donePoint = function (inde) { return __awaiter(void 0, void 0, void 0, function () {
        var cc;
        return __generator(this, function (_a) {
            cc = __spreadArray([], once.current, true);
            once.current = cc.map(function (one, id) {
                return id === inde ? true : one;
            });
            return [2 /*return*/];
        });
    }); };
    var getFileKey = function () { return __awaiter(void 0, void 0, void 0, function () {
        var promiseArr, keyFile, files, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    usingModal();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    once.current = submitExam === null || submitExam === void 0 ? void 0 : submitExam.answers.scratchAnswers.map(function () { return false; });
                    promiseArr = submitExam === null || submitExam === void 0 ? void 0 : submitExam.answers.scratchAnswers.map(function (url) { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            return [2 /*return*/, ContainerApiFp.containerDownload({ container: "studentFile", file: url.answerUrl }, authorization
                                    ? authorization
                                    : {
                                        headers: {
                                            authorization: au1h10k3N,
                                        },
                                    })()];
                        });
                    }); });
                    return [4 /*yield*/, Promise.all(promiseArr.map(function (p) { return p === null || p === void 0 ? void 0 : p.catch(function (e) { return e; }); }))];
                case 2:
                    keyFile = _a.sent();
                    return [4 /*yield*/, Promise.all(keyFile.map(function (file, index) { return __awaiter(void 0, void 0, void 0, function () {
                            var fileBlob;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, file.blob()];
                                    case 1:
                                        fileBlob = _a.sent();
                                        return [2 /*return*/, {
                                                name: index + numOfMulti + 1,
                                                file: fileBlob,
                                            }];
                                }
                            });
                        }); }))];
                case 3:
                    files = _a.sent();
                    setBaiMau(files);
                    setNumFile(files.length);
                    closeModal();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    closeModal();
                    console.error(e_1);
                    toast.error(errorMessage);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getMaxPoint = function () {
        var _a;
        var points = [];
        (_a = exam === null || exam === void 0 ? void 0 : exam.structureTest) === null || _a === void 0 ? void 0 : _a.forEach(function (struct) {
            if (struct.type === "SCRATCH") {
                points = points.concat(new Array(struct.amount).fill(struct.pointEachQuestion));
            }
        });
        setMaxPoint(points);
    };
    useEffect(function () {
        setCurrentFile(numOfMulti + 1);
    }, []);
    var getSubmitExam = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, StudentInfoApiFp.studentInfoFindById({ id: submitId }, authorization)()];
                case 1:
                    res = _a.sent();
                    setSubmitExam(res);
                    return [2 /*return*/];
            }
        });
    }); };
    var getTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        var filter, test, exam;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filter = {
                        where: { examId: examId },
                    };
                    return [4 /*yield*/, TestApiFp.testFindOne({ filter: JSON.stringify(filter) }, authorization)()];
                case 1:
                    test = _a.sent();
                    return [4 /*yield*/, ExamApiFp.examFindById({ id: test === null || test === void 0 ? void 0 : test.examId }, authorization)()];
                case 2:
                    exam = _a.sent();
                    setExam(exam);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (authorization && submitId) {
            getSubmitExam();
        }
    }, [submitId, authorization]);
    useEffect(function () {
        if (examId)
            getTest();
    }, [examId]);
    useEffect(function () {
        if (exam)
            getMaxPoint();
    }, [exam]);
    useEffect(function () {
        if (submitExam)
            getFileKey();
    }, [submitExam]);
    useEffect(function () {
        if (numFile === 0) {
            submit();
        }
    }, [numFile]);
    var toNextQues = function (e) {
        e.preventDefault();
        setCurrentFile(function (moment) { return moment + 1; });
        var curPoint = document.getElementById("point")
            .value;
        setPoints(__spreadArray(__spreadArray([], points, true), [
            { name: currentFile, point: parseInt(curPoint) },
        ], false));
        tmp.current = tmp.current + 1;
        setTotalPoint(function (curr) { return curr + parseInt(curPoint); });
        setNumFile(numFile - 1);
    };
    var submit = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            usingModal();
            StudentInfoApiFp.studentInfoPatchOrCreate({
                data: {
                    teacherScoring: totalPoint,
                    scored: true,
                    id: parseInt(submitId),
                },
            })()
                .then(function (res) {
                closeModal();
            })
                .catch(function (e) {
                closeModal();
                console.log(e);
                usingModal("ModalError");
            });
            return [2 /*return*/];
        });
    }); };
    var endTest = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            document.location.href = URL_BASE + "/tao-de-thi?ex=" + query.get("ex");
            return [2 /*return*/];
        });
    }); };
    return (_jsxs("div", __assign({ className: "show " + style.modal, style: { background: "rgba(0,0,0,0.5)" } }, { children: [_jsx("h2", __assign({ style: { textAlign: "center", fontSize: 40 + "px" }, className: "font-weight-bold" }, { children: numFile > 0 ? "CHẤM BÀI" : "HOÀN THÀNH CHẤM BÀI" }), void 0), _jsxs("div", __assign({ style: { textAlign: "center" } }, { children: ["H\u1ECDc sinh: ", submitExam === null || submitExam === void 0 ? void 0 : submitExam.name] }), void 0), numFile > 0 && (_jsx("img", { className: style.arrow, src: "../../../static/arrow.gif" }, void 0)), baiMau === null || baiMau === void 0 ? void 0 : baiMau.map(function (bai, ind) {
                return currentFile === bai.name && (_jsxs("div", { children: [_jsxs("div", __assign({ className: style.tuDanhGia }, { children: [_jsxs("h2", __assign({ style: { fontSize: 40 + "px" }, className: "font-weight-bold" }, { children: ["B\u00C0I GI\u1EA2I: C\u00C2U ", bai.name] }), void 0), _jsxs("div", __assign({ style: {
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        alignItems: "center",
                                    } }, { children: [_jsx("h5", __assign({ className: style.h5 }, { children: "CH\u1EA4M \u0110I\u1EC2M" }), void 0), _jsx("form", __assign({ onSubmit: function (e) { return toNextQues(e); }, method: "post" }, { children: _jsxs("div", __assign({ className: "input-group mb-3", style: { width: "250px" } }, { children: [_jsx("input", { autoFocus: true, required: true, type: "number", className: "form-control " +
                                                            style.input, "aria-label": "Recipient's username", "aria-describedby": "basic-addon2", placeholder: " .....", id: "point", max: maxPoints
                                                            ? maxPoints[ind]
                                                            : 0, min: 0 }, void 0), maxPoints && (_jsxs("label", __assign({ className: style.label }, { children: ["/", maxPoints[ind], " \u0111i\u1EC3m"] }), void 0)), _jsx("div", __assign({ className: "input-group-append" }, { children: _jsx("button", __assign({ className: "btn btn-danger " +
                                                                style.btn, type: "submit" }, { children: "X\u00E1c nh\u1EADn" }), void 0) }), void 0)] }), void 0) }), void 0)] }), void 0)] }), void 0), bai.file.type != "application/octet-stream" && (_jsx("h1", { children: "Ch\u01B0a c\u00F3 b\u00E0i gi\u1EA3i cho c\u00E2u h\u1ECFi n\u00E0y!" }, void 0))] }, ind));
            }), _jsxs("div", __assign({ 
                // className={
                //     baiMau[baiMau.findIndex((bai) => currentFile === bai.name)]
                //         ?.file?.type === "application/octet-stream"
                //         ? ""
                //         : style.display_none
                // }
                id: "pointingTarget" }, { children: [((_b = (_a = baiMau[baiMau.findIndex(function (bai) { return currentFile === bai.name; })]) === null || _a === void 0 ? void 0 : _a.file) === null || _b === void 0 ? void 0 : _b.type) != "application/octet-stream" && (_jsx("h1", { children: "H\u1ECDc sinh kh\u00F4ng n\u1ED9p b\u00E0i gi\u1EA3i cho c\u00E2u h\u1ECFi n\u00E0y!" }, void 0)), ((_c = submitExam === null || submitExam === void 0 ? void 0 : submitExam.answers.scratchAnswers[currentFile - 1]) === null || _c === void 0 ? void 0 : _c.answerUrl) === 'default.sb3' && (_jsx("h1", { children: "L\u01B0u \u00FD: H\u1ECDc sinh kh\u00F4ng n\u1ED9p b\u00E0i gi\u1EA3i cho c\u00E2u h\u1ECFi n\u00E0y!" }, void 0)), W[0] && (_jsx(AppTarget, { WrappedGui: W[0], closeScratch: nothingToDoHere, scratchFile: ((_d = baiMau[baiMau.findIndex(function (bai) { return currentFile === bai.name; })]) === null || _d === void 0 ? void 0 : _d.file)
                            ? (_e = baiMau[baiMau.findIndex(function (bai) { return currentFile === bai.name; })]) === null || _e === void 0 ? void 0 : _e.file
                            : null, once: once, index: tmp, setOnce: donePoint }, void 0))] }), void 0), numFile === 0 && (_jsxs("div", __assign({ style: { textAlign: "center" } }, { children: [_jsx("h2", __assign({ className: style.final }, { children: "S\u1ED0 \u0110I\u1EC2M \u0110\u00C1NH GI\u00C1" }), void 0), points.map(function (ele, ind) { return (_jsxs("h2", __assign({ className: style.h2 + " " + style.final }, { children: ["C\u00C2U ", ele.name, ": ", ele.point, " \u0110I\u1EC2M"] }), ind)); }), _jsxs("h1", __assign({ className: style.final, style: { fontWeight: "bolder" } }, { children: ["T\u1ED4NG S\u1ED0 \u0110I\u1EC2M T\u1EF0 LU\u1EACN C\u1EE6A B\u00C0I THI: ", totalPoint, " \u0111i\u1EC3m"] }), void 0), _jsx("button", __assign({ className: "btn " + style.final + " " + style.btnFinal, onClick: function () { return endTest(); } }, { children: "K\u1EBFt th\u00FAc" }), void 0)] }), void 0))] }), void 0));
};
